import * as semver from 'semver'

/**
 *
 * initially when rewards was launched, we added a new `mintWithRewards()` function to support it
 * later, we updated the original `mint()` function to support rewards, and now we need to remove
 * `mintWithRewards()` to save on 1155 contract size, so this helper will determine if we can safely
 * use `mint()` with rewards
 */
export const contractSupportsMintRewardsWithMintFunction = (
  contractVersion?: string | null,
  contractStandard?: 'ERC721' | 'ERC1155'
) => {
  if (!contractStandard || !contractVersion) {
    return false
  }

  // Try force-convert version format to semver format
  const semVerContractVersion = semver.coerce(contractVersion)?.raw
  if (!semVerContractVersion) return false

  if (contractStandard === 'ERC1155') {
    return semver.gte(semVerContractVersion, '2.9.0')
  } else {
    return false
  }
}
